// src/components/common/StatCard.jsx
import React from "react";

/**
 * Small card for dashboard metrics
 * props: title, value, delta, icon, iconBgColor, iconColor
 */
export default function StatCard({ 
  title, 
  value, 
  delta, 
  icon, 
  iconBgColor = "bg-gray-100 dark:bg-gray-800",
  iconColor = "text-gray-600 dark:text-gray-400"
}) {
  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-100 dark:border-gray-700 p-6 transition-colors duration-300 hover:shadow-md">
      <div className="flex items-center justify-between">
        <div>
          <div className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-1">
            {title}
          </div>
          <div className="text-2xl font-bold text-gray-900 dark:text-white">{value}</div>
          {delta && (
            <div className="text-xs text-emerald-500 mt-2 font-medium">
              {delta}
            </div>
          )}
        </div>
        {icon && (
          <div className={`p-3 rounded-xl flex items-center justify-center ${iconBgColor} ${iconColor}`}>
            {icon}
          </div>
        )}
      </div>
    </div>
  );
}
